import axios from "@/axios/axios";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  getters: {},
  actions: {
    loadXML(context, obj) {
      console.log(obj);
      return axios
        .get(obj.link, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          if (response.status == 200) {
            const fileName = obj.name ? obj.name : "검색이력.xlsx";
            console.log(fileName);
            const url = window.URL.createObjectURL(
              new Blob([response.data], {
                type: response.headers["content-type"],
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    equipmentDataList(context, payload){
      return axios
      .post('/api/equipmentData/list', {
        studyIdx: payload.studyIdx,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
        sortBy: payload.sortBy,
        sortDesc: payload.sortDesc,
        searchText : payload.searchText
      })
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    getAll() {
      return axios
        .get("/api/equipmentData/all")
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    getTitle(title) {
      console.log("getTitle : " + JSON.stringify(title))
      return axios
        .get("/api/equipmentData/get-by-title?title=" + title)
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    uploadEquipmentData(context, params) {
      var formData = new FormData();

      if (params.files && params.files.length > 0) {
        for (let i = 0; i < params.files.length; i++) {
          formData.append("files", params.files[i]);
        }
      }

      var encodedTitle = encodeURIComponent(params.title);
      
      //연구 등록시 studyIdx 초기화
      if(params.dataType){
        params.studyIdx = 0;
      }
      return axios
        .post(
          "/api/equipmentData/upload?title=" +
            encodedTitle +
            "&studyIdx=" +
            params.studyIdx +
            "&dataType=" +
            params.dataType,
          formData
        )
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    deleteEquipmentData(context, idxArray) {
      return axios
        .delete("/api/equipmentData/delete?idxArray=" + idxArray)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    deleteResearch(context, studyIdx) {
      return axios
        .delete("/api/equipmentData/deleteResearch?studyIdx=" + studyIdx)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },

    // InBody API
    getAllInBody() {
      return axios
          .post("/api/inBody/list")
          .then((response) => {
            if (response.status == 200) {
              return Promise.resolve(response.data);
            }

            return Promise.reject(response.message);
          })
          .catch((error) => {
            console.log(error);
            return Promise.reject(error);
          });
    },
    getAllInBodyData(context,targetIdx) {

      return axios
          .get("/api/inBody/allInBodyDetailData?targetIdx=" + targetIdx)
          .then((response) => {
            if (response.status == 200) {
              return Promise.resolve(response.data);
            }

            return Promise.reject(response.message);
          })
          .catch((error) => {
            console.log(error);
            return Promise.reject(error);
          });
    },
    insertInBodyInfo(context, inBodyInfoParams) {
      // var encodedTitle = encodeURIComponent(inBodyInfoParams.title);
      return axios
          .post("/api/inBody/insert", JSON.stringify(inBodyInfoParams))
          .then((response) => {
            if (response.status == 200) {
              return Promise.resolve(response.data);
            }

            return Promise.reject(response.message);
          })
          .catch((error) => {
            console.log(error);
            return Promise.reject(error);
          });
    },
    uploadInBodyData(context, params) {
      var formData = new FormData();
      formData.append("file", params.file);

      return axios
          .post(
              "/api/inBody/upload?targetIdx=" +
              params.targetIdx,
              formData
          )
          .then((response) => {
            if (response.status == 200) {
              return Promise.resolve(response.data);
            }

            return Promise.reject(response.message);
          })
          .catch((error) => {
            console.log(error);
            return Promise.reject(error);
          });
    },
    deleteInBody(context, params) {
        return axios
            .post("/api/inBody/delete", JSON.stringify(params))
            .then((response) => {
                if (response.status == 200) {
                    return Promise.resolve(response.data);
                }

                return Promise.reject(response.message);
            })
            .catch((error) => {
                console.log(error);
                return Promise.reject(error);
            });
    }

  },

  
};
